import NotificationType from "../../notification/notification-type.repository";

export default class notificationsSettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/partials/notification-settings.html'),
            controller: notificationsSettingsCtrl,
            controllerAs: 'notificationSettings'
        }
    }
};

class notificationsSettingsCtrl {

    constructor($scope, $timeout, Setting, Events, $filter, NotificationType) {

        this.settingRepo = Setting;
        this.notificationTypeRepo = NotificationType;
        this._timeout = $timeout;
        this._translator = $filter('translate');
        this._eventHandler = Events;

        this.loading = true;
        this.notificationTypeLocale = {
            'invalid_url': 'CUSTOMER_NOTIFICATIONS:TYPE:INVALID_URL',
            'promo_codes_exhausted': 'CUSTOMER_NOTIFICATIONS:TYPE:PROMO_CODES_EXHAUSTED',
            'missed_tag_in_segment': 'CUSTOMER_NOTIFICATIONS:TYPE:MISSED_TAG_IN_SEGMENT_ERROR',
            'request_rate_limit_achieved': 'CUSTOMER_NOTIFICATIONS:TYPE:RATE_LIMIT_ACHIEVED',
            'import_has_failed': 'CUSTOMER_NOTIFICATIONS:TYPE:IMPORT_FAILED',
            'facebook_account_requires_reconnection': 'CUSTOMER_NOTIFICATIONS:TYPE:FACEBOOK_ACCOUNT_REQUIRES_RECONNECTION',
        }

        this.settings = {
            notificationTypes: []
        };

        this.loadData();

    }

    checkedAll() {
        return this.settings.notificationTypes.length === this.settings.notificationTypes.filter(type => type.checked).length;
    }

    toggleAll() {
        let checked = this.checkedAll();
        this.settings.notificationTypes.forEach(type => {
            type.checked = !checked;
        });
    }

    saveSettings() {
        this.settingRepo.saveCustomerNotificationsSettings(this.settings)
            .then(() => {
                this._eventHandler.flashEvent('notification', this._translator('CUSTOMER_NOTIFICATIONS:FLASH:SAVE:SUCCESS'));
            }, (err) => {
                this._eventHandler.flashEvent('error', this._translator('CUSTOMER_NOTIFICATIONS:FLASH:SAVE:ERROR'));
            });
    }

    loadNotificationTypes() {
        this.notificationTypeRepo.customer().then(types => {
            this._timeout(() => {
                this.loading = false;
                this.notificationTypes = types.data;
            });
        }, () => {
            this.loading = false;
            this.failedToLoad = true;
        });
    }

    loadData() {
        this.settingRepo.getCustomerNotificationsSettings()
            .then(settings => {
                this._timeout(() => {
                    this.loading = false;
                    this.settings = settings.data;
                    this.notificationTypeRepo.customer().then(types => {
                        this._timeout(() => {
                            this.loading = false;
                            this.notificationTypes = types.data;
                            this.mapNotificationSettings();
                        });
                    }, () => {
                        this.loading = false;
                        this.failedToLoad = true;
                    });
                });
            }, () => {
                this.loading = false;
                this.failedToLoad = true;
            });
    }

    loadCustomerSettings() {
        this.settingRepo.getCustomerNotificationsSettings()
            .then(settings => {
                this._timeout(() => {
                    this.loading = false;
                    this.settings = settings.data;
                });
            }, () => {
                this.loading = false;
                this.failedToLoad = true;
            });
    }

    mapNotificationSettings() {
        if (typeof this.settings.notificationTypeSettings == null) {
            this.settings.notificationTypeSettings = {};
        }

        this.notificationTypes.map((type) => {
            if (!this.settings.notificationTypeSettings[type.id]) {
                this.settings.notificationTypeSettings[type.id] = {
                    'send_sms': false,
                    'send_email': false,
                    'send_ui_notification': false,
                    'notification_type_id': type.id,
                }
            }
            this.settings.notificationTypeSettings[type.id]['notification_type'] = this.addLocalizationKey(type)
        })
    }

    addLocalizationKey(notificationType) {
        if (notificationType.name) {
            if (this.notificationTypeLocale[notificationType.name]) {
                notificationType.locale = this.notificationTypeLocale[notificationType.name]
            }
        }

        return notificationType;
    }
}
